import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import html2pdf from 'html2pdf.js';

import { GuiaMedica } from 'src/app/shared/model/guia-medica.model';
import { AtendimentoService } from '../atendimento.service';
import { AuthService } from 'src/app/seguranca/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './detalhe-atendimento.component.html', styleUrls: ['./detalhe-atendimento.component.css']})
export class DetalheAtendimentoComponent implements OnInit {

  // Representar a guia médica
  guiaMedica = new GuiaMedica();
  subTotalProcedimentos = 0;
  subTotalOutrosProcedimentos = 0;

  constructor(config: NgbModalConfig, private modalService: NgbModal, private activatedRoute: ActivatedRoute,
      private router: Router, private atendimentoService: AtendimentoService, private toast: ToastrService,
      private authService: AuthService) {
      // customizar os valores default do modal.
      config.backdrop = 'static';
      config.keyboard = false;
  }

  ngOnInit() {
    // inscrever nos parâmetros de rota, toda a vez que ele mudar mesmo que o componente tenha sido carregado, uma ação será executada.
    this.activatedRoute.params.subscribe(params => {
      // Pegar o guiaId caso seja edição mapeado na URL.
      const guiaMedicaId = params['guiaId'];

      // Caso o usuário esteja editando uma guia buscar os dados.
      if (guiaMedicaId) {
        this.buscarGuiaMedica(guiaMedicaId);
      }
    });
  }

  /**
   * Método responsável por buscar os dados da guia.
   * @param guiaMedicaId identificador da guia médica.
   */
  buscarGuiaMedica(guiaMedicaId: number) {
    this.atendimentoService.buscar(guiaMedicaId).subscribe(
      dados => {
        this.guiaMedica = dados;

        // Calcular o subtotal dos procedimentos.
        this.guiaMedica.atendimentos.forEach(atend => this.subTotalProcedimentos += atend.quantidade * atend.valorUnitario);

        // Calcular o subtotal dos outros tipos de procedimentos.
        this.guiaMedica.atendimentosEstratificados.forEach(atend => this.subTotalOutrosProcedimentos += atend.valor);
      },
      (responseError) => {
        if (responseError instanceof HttpErrorResponse) {
          if (responseError.status === 404) {
            this.router.navigate(['/not-found']);
          } else if (responseError.status === 403) {
            this.router.navigate(['/nao-autorizado']);
          } else {
            this.toast.error('Ocorreu um erro ao processar a sua solicitação');
          }
        }
      }
    );
  }

  /**
   * Método para desabilitar os botoes para os prestadores caso o atendimento tenha sido finalizado.
   * @param atendimentoFinalizado status para saber se o atendimento foi finalizado
   */
  exibirBotoes(atendimentoFinalizado: boolean): boolean {
    return (this.authService.getLoggedUser().perfil === 1 || this.authService.getLoggedUser().perfil === 4) && atendimentoFinalizado;
  }

  /**
   * Método responsável por exbibir o template gerado no PDF.
   * @param content dados do template do modal.
   */
  modalPreExibicaoPDF(content) {
    this.modalService.open(content, { size: 'lg' });
    this.downloadAsPDF();

    // Método para finalizar o atendimento.
    if (!this.guiaMedica.finalizado) {
      this.atendimentoService.finalizarAtendimento(this.guiaMedica.id).subscribe(() => this.guiaMedica.finalizado = true);
    }
  }

  // Método responsável para gerar o PDF da guia médica.
  downloadAsPDF() {
    const options = {
      margin: 1,
        filename: 'Guia Médica.pdf',
        html2canvas: {
          dpi: 192,
          letterRendering: true,
          allowTaint: true,
          useCORS: true,
          logging: false,
          scrollX: 0,
          scrollY: 0
        },
        jsPDF: {
          orientation: 'portrait',
          unit: 'cm',
          format: 'a4'
        }
    };

    const element: Element = document.getElementById('table');

    html2pdf()
      .from(element)
      .set(options)
      .save();
  }
}
